import React from 'react';
import CustomTooltip from './CustomTooltip';

const TruncatedText = ({ text, maxWords = 10, className = "", style = {} }) => {
  if (!text) return <span className={className} style={style}>-</span>;

  const words = text.toString().split(' ');
  const shouldTruncate = words.length > maxWords;
  
  if (!shouldTruncate) {
    return <span className={className} style={style}>{text}</span>;
  }

  const truncatedText = words.slice(0, maxWords).join(' ') + '...';
  const fullText = text;

  return (
    <CustomTooltip title={fullText}>
      <span 
        className={`truncate-text ${className}`} 
        style={{
          cursor: 'pointer',
          ...style
        }}
      >
        {truncatedText}
      </span>
    </CustomTooltip>
  );
};

export default TruncatedText; 